module.exports = __webpack_public_path__ + "static/g-4-a64ddd79c21f4397c3f4390c4a0c04e7.jpg";